module.exports = __webpack_public_path__ + "img/d47c27bab1be3ec15a3b9df041951d25.374c40b2.png";